export default __webpack_public_path__ + "static/media/pravidla.70a9aba1.pdf";